export default __webpack_public_path__ + "static/media/edit-white-shift.0b8870f1.svg";